import styled from 'styled-components';

export default {
    UploaderContainer: styled.div.attrs({ className: 'uploader-container-div' })`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: 1px solid gray;
        width: 60%;
        max-width: 860px;
        margin: 20px 10px;
    `,
    UploaderInteractContainer: styled.div.attrs({ className: 'uploader-interact-container-div' })`
        display: flex;
        flex-direction: row;
        align-items: flex-start;
    `,
};
